"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepEffect = void 0;
var tslib_1 = require("tslib");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var react_1 = require("react");
// https://stackoverflow.com/a/54096391/5318303
var useDeepMemorize = function (value) {
    var ref = react_1.useRef();
    if (!isEqual_1.default(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
};
var useDeepMemorizes = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return values.map(useDeepMemorize);
};
var useDeepEffect = function (callback, values) {
    return react_1.useEffect(callback, useDeepMemorizes.apply(void 0, values));
};
exports.useDeepEffect = useDeepEffect;
exports.default = exports.useDeepEffect;
//# sourceMappingURL=deep-effect.js.map